module.exports = __webpack_public_path__ + "img/brand-pic2-07.ff9d0e57.png";